import { AUDIT_BASE_URL } from "../../utils/ApiUrls";

class AuditRiskService {
  /**
   * Search audit risks for autocomplete/dropdown
   * @param {string} accessToken - JWT access token
   * @param {string} searchTerm - Search query
   */
  async searchAuditRisks(accessToken, searchTerm = '') {
    try {
      const response = await fetch(`${AUDIT_BASE_URL}/risks/audit-risk-search/?q=${encodeURIComponent(searchTerm)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error searching audit risks',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  /**
   * Search risks from a specific audit plan for audit questions
   * @param {string} accessToken - JWT access token
   * @param {string} auditPlanId - ID of the audit plan
   * @param {string} searchTerm - Search query
   */
  async searchAuditPlanRisks(accessToken, auditPlanId, searchTerm = '') {
    try {
      const response = await fetch(`${AUDIT_BASE_URL}/risks/audit-plan-risks-search/?audit_plan_id=${auditPlanId}&q=${encodeURIComponent(searchTerm)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error searching audit plan risks',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }
}

const auditRiskService = new AuditRiskService();
export default auditRiskService;